import { useRecentlyViewedCompanies } from '@/components/Dashboard/components/RecentlyViewed/hooks/useRecentlyViewedCompanies';
import { NarrativeMiniValuatorHighlightedCompanyButton } from './NarrativeMiniValuatorHighlightedCompanyButton';

type Props = {
  onCompanySelect: (canonicalUrl: string) => void;
};

export const NarrativeMiniValuatorRecentlyViewedCompanies = ({
  onCompanySelect,
}: Props) => {
  const {
    data: recentlyViewedCompanies,
    status: recentlyViewCompaniesFetchStatus,
  } = useRecentlyViewedCompanies();
  const companies = Object.values(
    recentlyViewedCompanies?.entities ?? {}
  ).slice(0, 3);

  if (recentlyViewCompaniesFetchStatus === 'pending')
    return (
      <div className="grid gap-x1">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="grid grid-cols-[theme(spacing.x7)_1fr] grid-rows-[58px] gap-x1_5"
          >
            <div className="bones" />
            <div className="bones" />
          </div>
        ))}
      </div>
    );

  if (recentlyViewCompaniesFetchStatus === 'error' || !companies.length)
    return (
      <div className="text-xs text-softer">
        No recently viewed companies found
      </div>
    );

  return (
    <div role="group" className="grid gap-x0_5">
      {companies.map((company) => (
        <NarrativeMiniValuatorHighlightedCompanyButton
          key={company.canonicalUrl}
          canonicalUrl={company.canonicalUrl}
          onCompanySelect={onCompanySelect}
          tickerSymbol={company.tickerSymbol}
          url={company.url}
          name={company.name}
          countryIso2={company.countryIso2}
        />
      ))}
    </div>
  );
};
